/**
 * Do not edit directly
 */

export default "PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibS41LjV2MTVoMTV2LTE1em0xIDFoMTN2NWgtMTN6bTEzIDEzaC0xM3YtN2gxM3oiLz48cGF0aCBkPSJtMyAzLjVoNXYxaC01eiIvPjxwYXRoIGQ9Im0xMSAzLjVoMnYxaC0yeiIvPjwvc3ZnPg==";